define('wamessages', [],function () {

	var wamessages = {
		actLang: "de",
		de: {
			basket: "Warenkorb",
			catSelect: "Kategorie wählen",
			subCatSelect: "Unterkategorie wählen",
			shopping: "Weiter shoppen",
			tooManyColors: "Ihre Farbmusterbestellung kann bis zu 3 Farben enthalten. Bitte entfernen Sie eine ausgewählte Farbe und wählen Sie dann erneut.",
			choseAllSlects: "Bitte wählen Sie alle Auswahlboxen aus.",
			choseAllInputs: "Bitte tragen Sie etwas in das Eingabefeld ein.",
			bahnenwaehler: "Bitte wählen Sie min. eine Tapetenbahn aus.",
			categorys: "Kategorien",
			noticeMsg: "Der Artikel wurde Ihrem Merkzettel hinzugefügt.",
			loginBoxMsgNoticeList: "Für Merkzettel bitte anmelden.",
			chooseMax20Characters: "Bitte verwenden Sie maximal 32 Zeichen",
			notBuyableArticle: "Dieser Artikel ist nicht kaufbar.",
			inBasket: "Der Artikel wurde Ihrem Warenkorb hinzugefügt.",
			acceptableCards: "Wir akzeptieren nur VISA, MasterCard und American Express.",
			noDelivery: "Ein Lieferung in dieses Land ist leider nicht möglich.",
			fieldMessages: {
				"invadr[oxuser__oxfname]": "Bitte geben Sie Ihren Vornamen an.",
				"invadr[oxuser__oxlname]": "Bitte geben Sie Ihren Nachnamen an.",
				"invadr[oxuser__oxstreet]": "Bitte geben Sie Ihre Straße an.",
				"invadr[oxuser__oxstreetnr]": "Bitte geben Sie Ihre Hausnummer an.",
				"invadr[oxuser__oxzip]": "Bitte geben Sie Ihre Postleitzahl an.",
				"invadr[oxuser__oxcity]": "Bitte geben Sie Ihren Wohnort an."
			},
			lastSearch: "Letzte Suche"
		},
		en: {
			basket: "Basket",
			catSelect: "Choose categorie",
			subCatSelect: "Choose subcategorie",
			shopping: "Continue shopping",
			tooManyColors: "You can choose up to 3 different colours. Please remove one of the colours and make your choice again.",
			choseAllSlects: "Please select all the boxes.",
			choseAllInputs: "Please fill in the text box.",
			bahnenwaehler: "Please choose at least one length.",
			categorys: "Categories",
			loginBoxMsgNoticeList: "Please login to access your wishlist.",
			chooseMax20Characters: "Please use a maximum of 20 characters",
			notBuyableArticle: "This product is not available.",
			inBasket: "This product has been added to your basket.",
			acceptableCards: "We only accept VISA, MasterCard and American Express.",
			noDelivery: "Shipping to this country is not possible."
		},
		nl: {
			basket: "Mandje",
			catSelect: "Choose categorie",
			subCatSelect: "Choose subcategorie",
			shopping: "Winkel verder",
			tooManyColors: "U kunt maximaal 3 kleurenstaaltjes aanvragen. Verwijder a.u.b. een kleurenstaal en kies opnieuw.",
			choseAllSlects: "Selecteer a.u.b. alle velden",
			choseAllInputs: "Vul a.u.b. alle velden in",
			bahnenwaehler: "Selecteer a.u.b. tenminste één baan",
			categorys: "Categorieën",
			loginBoxMsgNoticeList: "Log in om je verlanglijst te bekijken.",
			chooseMax20Characters: "Gebruik maximaal 20 tekens",
			notBuyableArticle: "Dit artikel is niet verkrijgbaar.",
			inBasket: "Het artikel is toegevoegd aan uw mandje.",
			acceptableCards: "Wij accepteren alleen VISA, MasterCard en American Express.",
			noDelivery: "Verzenden naar dit land is helaas niet mogelijk"
		},
		fr: {
			basket: "Panier",
			catSelect: "Choisir une catégorie",
			subCatSelect: "Choisir une sous-catégorie",
			shopping: "Continuer mes achats",
			tooManyColors: "Vous pouvez choisir jusqu'à 3 échantillons de couleurs. Merci de supprimer une couleur sélectionnée et de refaire votre choix.",
			choseAllSlects: "Merci de choisir tous les champs.",
			choseAllInputs: "Merci de saisir le champ texte .",
			bahnenwaehler: "Merci de choisir au minimum un lé.",
			categorys: "Catégories",
			loginBoxMsgNoticeList: "Merci de vous connecter pour accéder à votre liste d'envies.",
			chooseMax20Characters: "S'il vous plaît utiliser un maximum de 20 caractères",
			notBuyableArticle: "Vous ne pouvez pas commander cet article.",
			inBasket: "Votre article a été ajouté à votre panier.",
			acceptableCards: "Nous n'acceptons que les cartes VISA, MasterCard et American Express.",
			noDelivery: "Les livraisons vers ce pays ne sont malheureusement pas possibles"
		},
		dk: {
			basket: "Kurv",
			catSelect: "Vælg kategori",
			subCatSelect: "Vælg underkategori",
			shopping: "Fortsæt indkøb",
			tooManyColors: "Du kan vælge op til 3 forskellige farver, fjern venligst en farve og prøv igen.",
			choseAllSlects: "Vælg venligst alle boksene",
			choseAllInputs: "Udfyldt venligst tekst-boksen",
			bahnenwaehler: "Du kan mindst vælge én længde",
			categorys: "Kategorier",
			chooseMax20Characters: "Brug en maksimum 20 bogstaver",
			notBuyableArticle: "Dette produkt kan ikke købes.",
			inBasket: "Dette produkt er nu blevet tilføjet til din kurv.",
			acceptableCards: "Vi accepterer kun VISA, MasterCard og American Express.",
			noDelivery: "Forsendelse til disse lande er ikke muligt."
		},
		it: {
			basket: "Carello",
			catSelect: "Scegli la categoria",
			subCatSelect: "Scegli la sottocategoria",
			shopping: "Contina lo shopping",
			tooManyColors: "Seleziona fino a 3 colori diversi. Si prega di rimuovere uno dei colori e di effettuare di nuovo la scelta.",
			choseAllSlects: "Seleziona tutti i campi.",
			choseAColor: "Seleziona un colore.",
			choseAllInputs: "Inserisci il testo.",
			bahnenwaehler: "Seleziona almeno una striscia.",
			categorys: "Categorie",
			loginBoxMsgNoticeList: "Accedi per la lista desideri",
			chooseMax20Characters: "Si prega di utilizzare un massimo di 20 caratteri",
			notBuyableArticle: "Questo articolo non è acquistabile.",
			inBasket: "Questo prodotto è stato aggiunto al carrello.",
			acceptableCards: "Accettiamo solo VISA, MasterCard e American Express.",
			noDelivery: "La spedizione in questo paese non è  purtroppo possibile"
		}
	};

	window.wamessages = wamessages;

	return wamessages;
});

